/** @jsx jsx */
import { jsx } from '@emotion/react'
import { HeaderContent } from '../assets/styles/HeaderContent.styles'
import { Col, Container, Row } from 'react-bootstrap'
import { useState, useEffect } from 'react'
import BgHomeMobile from '../assets/images/LP-arabe/BgHomeM.png'

const HeaderSlider = () => {
  const palavras = ['عربي', 'Árabe']
  const [index, setIndex] = useState(0)
  const [fade, setFade] = useState(true)

  useEffect(() => {
    const id = setInterval(() => {
      setFade(false)
      setTimeout(() => {
        setIndex((i) => (i + 1) % palavras.length)
        setFade(true)
      }, 300)
    }, 3000)

    return () => clearInterval(id)
  }, [])

  return (
    <section css={HeaderContent}>
      <div>
        <img src={BgHomeMobile} className="img-mobile" />
      </div>
      <Container>
        <Row data-aos="fade-down" data-aos-delay="500" className='title-sec'>
          <Col lg={6} md={6} sm={12}>
            <h1>
              Educação com excelência e respeito à identidade{' '}
              <span
                css={{
                  transition: 'opacity 0.3s ease',
                  opacity: fade ? 1 : 0,
                  color: '#E63946',
                  fontWeight: '700',
                  display: 'inline-block',
                  minWidth: '5ch' 
                }}
              >
                {palavras[index]}
              </span>
            </h1>
            <p>
              Na Escola Árabe Bertoni, a Educação Infantil e o Ensino Fundamental Anos Iniciais unem excelência acadêmica,
              valores islâmicos e cultura árabe em um ambiente seguro.
            </p>
            <a
              className="button-link"
              href="/sobre-nos"
            >
              Saiba mais!
            </a>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default HeaderSlider
